import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { LOGO_CRESCENT } from "@/components/landing/data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e.msg).join(" ") : "Login failed.");
const input = "mt-3 w-full h-14 px-5 rounded-full bg-[#ffffff] border border-[#e3e2dc] text-sm outline-none focus:border-[#ff2a85]/60 transition-colors";

export const AdminGate = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const r = await axios.post(`${API}/auth/login`, { email: email.trim(), password }, { withCredentials: true });
      onSuccess(r.data.token);
    } catch (err) {
      setError(fmt(err?.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 hero-radial" />
      <motion.form
        data-testid="admin-login-form"
        onSubmit={submit}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 w-full max-w-sm bg-[#faf9f6] border border-[#e3e2dc] rounded-3xl p-10"
      >
        <img src={LOGO_CRESCENT} alt="Deen District" className="h-10 w-10 mb-8" />
        <span className="inline-flex items-center gap-2 font-mono-d text-[10px] uppercase tracking-[0.25em] text-[#ff2a85]">
          <Lock size={12} /> Restricted
        </span>
        <h1 className="font-display font-extrabold uppercase text-3xl mt-3 leading-none">
          Drop 001 <span className="text-pink">Admin</span>
        </h1>
        <p className="text-[#5f5e5a] text-sm mt-3">Sign in to manage subscribers, pre-orders and products.</p>
        <input data-testid="admin-email-input" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoFocus className={`${input} mt-8`} />
        <input data-testid="admin-password-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={input} />
        {error && (
          <p data-testid="admin-login-error" className="mt-3 text-xs text-[#ff2a85] font-mono-d uppercase tracking-wider">{error}</p>
        )}
        <button
          data-testid="admin-login-button"
          type="submit"
          disabled={loading}
          className="mt-4 w-full h-14 rounded-full bg-[#ff2a85] hover:bg-[#e60067] disabled:opacity-60 text-white font-mono-d text-[11px] uppercase tracking-[0.2em] transition-colors flex items-center justify-center"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign in"}
        </button>
      </motion.form>
    </div>
  );
};
